import { ReactComponent } from "./loading_line.svg";

interface Props {
  fill?: string;
}

const ArrowDownLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ArrowDownLineIcon;
